<template>
    <div>
        <Documentos idSeccion='1'/>
    </div>
</template>

<script>
import Documentos from '@/components/Documentos'
import {mapState} from 'vuex'

export default {
    name: 'ReglamentoConstruccion',
    props: {
    },
    data() {
        return {
            variable: ''
        }
    },
    created() {
    },
    components: {
        Documentos
    },
    computed: {
        ...mapState(['token'])
    }
}
</script>

<style scoped>

</style>